import { lazy, useCallback } from 'react';

import { IconSizes } from '@pulse-web-ui/icons/lib/icons.constants';

import { RGS_CAREER } from '@shared/constants';
import { BackButton, ColumnContainer, StateBlock } from '@shared/ui';

import { useTranslation } from '../../../helpers';
import { Container } from './remote-registration-unavailable-block.styles';

const AgentIcon = lazy(() => import('@pulse-web-ui/icons/lib/lazy/rgs-agent'));

interface RemoteRegistrationUnavailableBlockProps {
  onBack: () => void;
}

export const RemoteRegistrationUnavailableBlock = ({
  onBack,
}: RemoteRegistrationUnavailableBlockProps) => {
  const t = useTranslation();

  const handleOnSubmit = useCallback(() => {
    window.open(RGS_CAREER, '_blank');
  }, []);

  return (
    <Container>
      <ColumnContainer
        $gap={24}
        $align='flex-start'
      >
        <BackButton
          goBack={onBack}
          testId='remote-registration-unavailable-back-button'
        />
        <StateBlock
          title={t('remoteRegistrationUnavailableBlock.title')}
          description={t('remoteRegistrationUnavailableBlock.description')}
          icon={<AgentIcon size={IconSizes.large} />}
          testId={'remote-registration-unavailable'}
          submitButtonText={t('remoteRegistrationUnavailableBlock.button')}
          onSubmit={handleOnSubmit}
        />
      </ColumnContainer>
    </Container>
  );
};
